import { Skeleton } from '@/shared/components/shadcn'
import { MobileBlockSkeleton } from 'syncra-storybook/features'

export function SmallBaseTableSkeleton() {
  return (
    <div>
      <div className="hidden md:flex flex-col space-y-0">
        {Array.from({ length: 2 }).map((_, index) => (
          <div
            key={index}
            className="flex justify-between items-center p-3 border-b last:border-b-0"
          >
            <div className="w-1/8">
              <Skeleton className="w-6 h-6" />
            </div>
            <div className="flex items-center space-x-4 w-1/3">
              <Skeleton className="rounded-full w-8 h-8" />
              <div className="flex flex-col space-y-1">
                <Skeleton className="w-40 h-4" />
                <Skeleton className="w-32 h-4" />
              </div>
            </div>

            <div className="w-1/3">
              <Skeleton className="w-40 h-6" />
            </div>

            <div className="w-1/3">
              <Skeleton className="w-40 h-4" />
            </div>

            <div className="flex justify-end items-center w-1/3">
              <Skeleton className="w-24 h-4" />
              <Skeleton className="ml-4 w-5 h-4" />
            </div>
          </div>
        ))}
      </div>
      <div className="md:hidden flex flex-col">
        {Array.from({ length: 4 }).map((_, index) => (
          <MobileBlockSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}
